import React, { useEffect, useState } from "react";
import "./Cards.css";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import {
  getdistictName,
  getAllBlocksFromDistrict,
  get_total_limit_used_balance,
  district_wise_fund,
  fund_recieved_dwo,
} from "../../api/Users";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";

import Map from "../Map/Map";
import { toast } from "react-toastify";
import { Typography, TablePagination } from "@mui/material";

const style = {
  bgcolor: "background.paper",
  boxShadow: 24,
  border: "0px !important",
  p: 4,
};

const FundCards = (props) => {
  console.log(props);
  const { t } = useTranslation();

  const [modalHeader, setModalHeader] = useState("");
  const [modalData, setModalData] = useState([]);
  const [DistrictName, setDistrictName] = useState([]);
  const [District, setDistrict] = useState("");
  const [Allblocks, setAllBlocks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [limitAllocationData, setLimitAllocationData] = useState([]);

  const [limits, setLimits] = useState({
    limitsAllocated: 0,
    limitsRemaining: 0,
    limitUsed: 0,
    lastMonth: 0,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [funds, setFunds] = useState({
    north: [],
    central: [],
    south: [],
  });

  useEffect(() => {
    getDistictNames();
    getFundCardsData();

    setIsLoading(true);
    district_wise_fund()
      .then((res) => {
        if (res.status === "success") {
          setFunds({
            north: res.data.north,
            central: res.data.central,
            south: res.data.south,
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });
  }, []);

  const getFundCardsData = () => {
    const limitsData =
      props.role == 4
        ? {
            role_id: 4,
            school_id: props.userData.school_id,
          }
        : props.role == 5
        ? {
            role_id: 5,
            district_code: props.userData.district_code,
            block_code: props.userData.block_code,
            school_id: "all",
          }
        : props.role == 6
        ? {
            role_id: props.role == 6 ? 6 : "",
            district_code: props.userData.district_code,
            block_code: "all",
            school_id: "all",
          }
        : {
            role_id: 8,
            district_code: District === "" ? "all" : District,
            block_code: "all",
            school_id: "all",
          };

    get_total_limit_used_balance(limitsData)
      .then((res) => {
        setLimits({
          limitsAllocated: res.data.result[0].limit_allocated,
          limitsRemaining: res.data.result[0].limit_remaining,
          limitUsed: res.data.result[0].limit_used,
          lastMonth: res.data.result[0].limit_used_last_month,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
        setIsLoading(false);
      });
  };
  const handleFundType = async (e) => {
    setFundType(e.target.value);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };
  const [fundType, setFundType] = useState("all");

  const [open, setOpen] = React.useState(false);
  const onOpenModal = (data) => {
    if (data === 0) {
      setModalHeader("Total Students");
      setModalData(props.hostelWiseStudents);
    } else if (data === 1) {
      setModalHeader("Total Staff");
      setModalData(props.hostelWiseStaff);
    }
    setOpen(true);
  };

  const getDistictNames = () => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setDistrictName(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setDistrict(e.target.value);
    setAllBlocks([]);

    getAllBlocksFromDistrict(selectedDistrictId).then((res) => {
      if (res.status == "success") {
        setAllBlocks(res.data.new_asset_query);
      } else {
        setAllBlocks([]);
      }
    });
  };

  const getLimitAllicationData = (fundtype) => {
    setIsLoading(true);
    const data = {
      fund_master_id: fundtype,
      district_code: props.userData.district_code,
    };

    fund_recieved_dwo(data)
      .then((response) => {
        if (response.status == "success") {
          setIsLoading(false);
          setLimitAllocationData(response.data.result);
        } else {
          setIsLoading(false);
          setLimitAllocationData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  useEffect(() => {
    getLimitAllicationData("all");
  }, []);

  return (
    <div className="row">
      <div className="row justify-content-between mb-3">
        <div className="col-6 d-flex align-items-center">
          <h3 className="fs-4 mt-4">{"Fund"}</h3>
        </div>
        {props.role == 6 ? (
          <div
            className="col-6 d-flex align-items-center"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
          >
            {/* <div
              className="AmenityFilter row"
              style={{ display: "flex", flexDirection: "row" }}
            > */}
            <div className="col-md-5 mx-2">
              <label className="form-label">
                {t("Fund Type")} <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="asset_type_id"
                className="common-input form-select"
                onChange={handleFundType}
                value={fundType}
                required
              >
                {/* <option value="">{t("Select Fund Type")}</option> */}
                <option value="all">{t("All")}</option>
                <option value="1">{t("Generic")}</option>
                <option value="2">{t("Additional")}</option>
              </select>
            </div>
            <div className="col-md-3 mx-2">
              <button
                type="button"
                className="btn btn-primary btn-sm  mx-2"
                style={{ marginTop: "30px" }}
                onClick={() => getLimitAllicationData(fundType)}
              >
                {t("Search")}
              </button>
            </div>
            {/* </div> */}
          </div>
        ) : (
          ""
        )}
        <div className="col-6 d-flex align-items-center justify-content-end">
          {props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <div className="col-md-3 mx-2">
              <label htmlFor="title" className="form-label">
                {t("District")}
              </label>
              <select
                name="asset_sub_type"
                onChange={handleDistrictChange}
                className="common-input form-select"
              >
                <option value="all">All</option>
                {DistrictName &&
                  DistrictName.map((row, id) => (
                    <option
                      key={id}
                      value={row.district_code}
                      className="text-dark"
                    >
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}

          {props.role == 8 ||
          props.role == 11 ||
          props.role == 12 ||
          props.role == 13 ? (
            <button
              className="btn btn-primary btn-sm  mx-2"
              style={{ marginTop: "28px" }}
              onClick={getFundCardsData}
            >
              {t("Search")}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="my-3 col-12 d-flex align-items-center justify-content-between">
        <div className="col-md-3 mx-1">
          <div className="card card2">
            <div className="card-body hello2">
              <h3 className="card-title text-white">{t("Total Fund")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {limits.limitsAllocated > 0 ? limits.limitsAllocated : 0}
                    {/* {props.props.role == 8
                      ? limits.limitsAllocated > 0
                        ? limits.limitsAllocated
                        : 0
                      : 0} */}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card3">
            <div className="card-body hello3">
              <h3 className="card-title text-white">{t("Used")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {limits.limitUsed > 0 ? limits.limitUsed : 0}
                    {/* {props.props.role == 8
                      ? limits.limitUsed > 0
                        ? limits.limitUsed
                        : 0
                      : 0} */}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card1">
            <div className="card-body hello1">
              <h3 className="card-title text-white">{t("Remaining")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {limits.limitsAllocated - limits.limitUsed}
                    {/* {props.props.role == 8
                      ? limits.limitsRemaining > 0
                        ? limits.limitsRemaining
                        : 0
                      : 0} */}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mx-1">
          <div className="card card3">
            <div className="card-body hello4">
              <h3 className="card-title text-white">{t("Last Month Used")}</h3>
              <h6 className="text-white">
                {t("")}
                <br />
              </h6>
              <motion.div>
                <div className="radialBar d-flex justify-content-end">
                  <span className="text-white larger-text fs-3">
                    {limits.lastMonth > 0 ? limits.lastMonth : 0}
                    {/* {props.props.role == 8
                      ? limits.lastMonth > 0
                        ? limits.lastMonth
                        : 0
                      : 0} */}
                  </span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="limitAllocationDWO"
        style={{
          display: props.role == 6 ? "flex" : "none",
          flexDirection: "column",
        }}
      >
        {/* <form action="" id="myform" style={{ marginTop: "3rem" }}>
            <div className="AmenityFilter row" style={{ marginTop: "12px" }}>
              <div className="col-md-3">
                <label className="form-label">
                  {t("Fund Type")} <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="asset_type_id"
                  className="common-input form-select"
                  onChange={handleFundType}
                  value={fundType}
                  required
                >
                  <option value="all">{t("All")}</option>
                  <option value="1">{t("Generic")}</option>
                  <option value="2">{t("Additional")}</option>
                </select>
              </div>
              <div className="col-md-3">
                <button
                  type="button"
                  className="btn btn-primary btn-sm  mx-2"
                  style={{ marginTop: "35px" }}
                  onClick={() => getLimitAllicationData(fundType)}
                >
                  {t("Search")}
                </button>
              </div>
            </div>
          </form> */}
        <h5 className="my-3 mb-3">{t("Allocated Limits")}</h5>

        <TableContainer
          component={Paper}
          style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
          className="my-4"
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="border border-0">
                  {t("Sr. No.")}
                </TableCell>
                <TableCell align="center" className="border border-0">
                  {t("Fund Type")}
                </TableCell>
                <TableCell align="center" className="border border-0">
                  {t("Fund Sub Type")}
                </TableCell>
                <TableCell align="center" className="border border-0">
                  {t("Fund Received")}
                </TableCell>
              </TableRow>
            </TableHead>
            {!isLoading &&
              limitAllocationData &&
              limitAllocationData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {limitAllocationData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {getSerialNumber(index)}
                        </TableCell>
                        <TableCell align="center">{row.head_name}</TableCell>
                        <TableCell align="center">
                          {row.sub_type_name}
                        </TableCell>
                        <TableCell align="center">{row.total_limit}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
            {!isLoading &&
              (!limitAllocationData || limitAllocationData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={limitAllocationData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      <h3
        className="text-dark my-4 col-12"
        style={{
          display: props.role == 6 || props.role == 7 ? "none" : "block",
        }}
      >
        {t("District Wise - Funds Allocated")}
      </h3>
      <div
        className="my-2 mx-3 col-12 justify-content-center align-items-center"
        style={{
          display: props.role == 6 || props.role == 7 ? "none" : "flex",
        }}
      >
        <div className="col-12 d-flex justify-content-between ">
          <div className="col-4 d-flex row justify-content-center">
            {/* <span className="text-dark text-center mb-5 fw-bold">
              {t("Central Division (HQ – Cuttack)")}
            </span> */}
            <ul class="list-group mt-2">
              <li class="list-group-item p-3 px-4 d-flex justify-content-between align-items-center">
                <span
                  className="text-secondary fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  District
                </span>
                <span
                  className="text-secondary fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  Funds Allocated (in Rs Cr)
                </span>
              </li>
              {funds.central.map((data) => (
                <li class="list-group-item p-3 px-4 d-flex justify-content-between">
                  <span>{data.district}</span>
                  <span>{data.limit}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-4 d-flex row justify-content-center">
            {/* <span className="text-dark text-center fw-bold">
              {t("Northern Division (HQ – Sambalpur)")}
            </span> */}
            <ul class="list-group">
              <li class="list-group-item mt-2 p-3 px-4 d-flex justify-content-between align-items-center">
                <span
                  className="text-secondary fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  District
                </span>
                <span
                  className="text-secondary fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  Funds Allocated (in Rs Cr)
                </span>
              </li>
              {funds.north.map((data) => (
                <li class="list-group-item p-3 px-4 d-flex justify-content-between">
                  <span>{data.district}</span>
                  <span>{data.limit}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-4 d-flex row justify-content-center">
            {/* <span className="text-dark text-center fw-bold">
              {t("Southern Division (HQ – Berhampur)")}
            </span> */}
            <ul class="list-group">
              <li class="list-group-item p-3 mt-2 px-4 d-flex justify-content-between align-items-center">
                <span
                  className="text-secondary fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  District
                </span>
                <span
                  className="text-secondary fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  Funds Allocated (in Rs Cr)
                </span>
              </li>
              {funds.south.map((data) => (
                <li class="list-group-item p-3 px-4 d-flex justify-content-between">
                  <span>{data.district}</span>
                  <span>{data.limit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundCards;
